import * as ActionTypes from "./ActionTypes";

export const setGigmiCharges = (data) => {
  return {
    type: ActionTypes.SET_GIGMI_CHARGES,
    data,
  };
};
